import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.me/5491112345678" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-40 flex items-center gap-3 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group font-['Inter']" aria-label="Contactar por WhatsApp" data-id="element-38">
      <span className="font-medium text-sm hidden md:block group-hover:block whitespace-nowrap overflow-hidden" data-id="element-39">
        ¿Dudas? Consultanos
      </span>
      <div className="relative flex items-center justify-center" data-id="element-40">
        <div className="absolute inset-0 bg-white rounded-full opacity-40 animate-ping" data-id="element-41"></div>
        <MessageCircle className="w-6 h-6 relative z-10" data-id="element-42" />
      </div>
    </a>;
}